// extracted by mini-css-extract-plugin
module.exports = {"wx2tdb1":"wx2tdb1","i1q5keel":"i1q5keel","nguumd2":"nguumd2"};